import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";
import { BeatLoader } from "react-spinners";

const SFConfirmAlert = ({
    open,
    title,
    description,
    onConfirm,
    onCancel,
    loading
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="sf-confirm-dialog-title"
            aria-describedby="sf-confirm-dialog-description"
        >
            {title && (
                <DialogTitle id="sf-confirm-dialog-title">
                    {title}
                </DialogTitle>
            )}

            {description && (
                <DialogContent>
                    <DialogContentText id="sf-confirm-dialog-description">
                        {description}
                    </DialogContentText>
                </DialogContent>
            )}

            <DialogActions>
                <Button onClick={onCancel} variant="outlined" disabled={loading}>
                    Cancel
                </Button>
                <Button onClick={() => {
                    if (loading) return;
                    onConfirm();
                }} variant="contained" >
                    {loading ? <BeatLoader loading={true} color="#fff" size={12} /> : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SFConfirmAlert;
